import React, { Component } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faHashtag, faList } from "@fortawesome/free-solid-svg-icons";

import { SearchType } from "../../helper/type_helper";

class SearchDataSelection extends Component {
  state = {};

  render() {
    var usersClass = "btn btn_primary selection ";
    var hashtagsClass = "btn btn_primary selection ";
    var recommendationClass = "btn btn_primary selection ";
    switch (this.props.show) {
      case SearchType.recommendations: {
        recommendationClass += "selection_active";
        break;
      }
      case SearchType.hashtags: {
        hashtagsClass += "selection_active";
        break;
      }
      case SearchType.users: {
        usersClass += "selection_active";
        break;
      }
      default: {
      }
    }

    return (
      <div className="row pt-1 max_width_500">
        {/* <div className="width_profile_selection">
          <button
            className={recommendationClass}
            onClick={this.props.handleChangeToRecommendation}
          >
            <FontAwesomeIcon icon={faList} />
          </button>
        </div>
        <div className="width_profile_selection">
          <button
            className={hashtagsClass}
            onClick={this.props.handleChangeToHashtag}
          >
            <FontAwesomeIcon icon={faHashtag} />
          </button>
        </div> */}
        <div className="width_profile_selection" />
        <div className="width_profile_selection">
          <button
            className={usersClass}
            onClick={this.props.handleChangeToUser}
          >
            <FontAwesomeIcon icon={faUser} />
          </button>
        </div>
        <div className="width_profile_selection" />
      </div>
    );
  }
}

export default SearchDataSelection;



// WEBPACK FOOTER //
// ./src/components/search/search_data_selection.jsx